import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { forwardRef, type ComponentPropsWithoutRef, type ElementRef } from "react";

const Accordion = AccordionPrimitive.Root;

const AccordionItem = forwardRef<ElementRef<typeof AccordionPrimitive.Item>, ComponentPropsWithoutRef<typeof AccordionPrimitive.Item>>(({ className = "", value, ...props }, ref) => (
	<AccordionPrimitive.Item ref={ref} className={`border-b border-gray-200 last:border-b-0 ${className}`} value={value} data-accordion-value={value} {...props} />
));
AccordionItem.displayName = "AccordionItem";

interface AccordionTriggerProps extends ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger> {
	description?: string;
}

const AccordionTrigger = forwardRef<ElementRef<typeof AccordionPrimitive.Trigger>, AccordionTriggerProps>(({ className = "", children, description, ...props }, ref) => (
	<AccordionPrimitive.Header className="flex">
		<AccordionPrimitive.Trigger ref={ref} className={`flex flex-1 items-center justify-between px-6 py-4 text-left transition-all hover:opacity-80 group ${className}`} {...props}>
			<div className="flex-1">
				<span className="text-sm font-semibold text-gray-900">{children}</span>
				{description && <p className="text-xs text-tertiary mt-0.5">{description}</p>}
			</div>
			<svg className="h-4 w-4 shrink-0 text-gray-500 transition-transform duration-200 group-data-[state=open]:rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24">
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
			</svg>
		</AccordionPrimitive.Trigger>
	</AccordionPrimitive.Header>
));
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;

const AccordionContent = forwardRef<ElementRef<typeof AccordionPrimitive.Content>, ComponentPropsWithoutRef<typeof AccordionPrimitive.Content>>(({ className = "", children, ...props }, ref) => (
	<AccordionPrimitive.Content ref={ref} className="overflow-y-hidden overflow-x-visible text-sm accordion-content" {...props}>
		<div className={`px-6 pb-4 ${className}`}>{children}</div>
	</AccordionPrimitive.Content>
));
AccordionContent.displayName = AccordionPrimitive.Content.displayName;

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
